module.exports = __webpack_public_path__ + "static/media/dimensions-icon.cb855a7a.svg";